import G6 from '@antv/g6-pc';

G6.version = '4.7.4';

export * from '@antv/g6-pc';
export default G6;
export const version = '4.7.4';
